import React, { useEffect, useState } from 'react'
import {
  CBadge,
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import Swal from 'sweetalert2'

import { NotificationModel } from '../models'

const notification_model = new NotificationModel()

const TheHeaderDropdownNotif = (props) => {
  let { count_not_seen, data, } = props.notify.notifications || []
  const [isshow, setIsshow] = useState(false)
  const [limit, setLimit] = useState(99)
  const [allRead, setAllRead] = useState(false)

  //let notifications = data && data.filter((item, idx) => idx < limit)

  const _onRead = async (checkRead, code, url) => {
    if (checkRead) {
      const res = await notification_model.updateNotificationBy({
        notification_code: code,
        user_code: props.user.user_code
      })
      if (res.require) {
        props.notify.sendNotifications("notification:fetch-notify", { name: "updated" }, () => { })
        window.location.assign('/#' + url)
      } else {
        Swal.fire({ title: "ข้อผิดพลาด !", text: 'ไม่สามารถโหลดข้อมูล', icon: "error", })
      }
    } else {
      window.location.assign('/#' + url)
    }
    onSetLimit(99, false)
  }

  const _onReadAll = async (check) => {
    if (check) {
      const res = await notification_model.updateNotificationAll({
        user_code: props.user.user_code
      })
      if (res.require) {
        setIsshow(false)
        props.notify.sendNotifications("notification:fetch-notify", { name: "updated" }, () => { })
      }
    }
    setAllRead(check)
  }

  const onSetLimit = (limit, show) => {
    setLimit(limit)
    setIsshow(show)
  }

  return (
    <CDropdown inNav className="c-header-nav-item mx-2">
      <CDropdownToggle className="c-header-nav-link" caret={false}>
        <CIcon name="cil-bell" />
        <CBadge shape="pill" color="danger">{count_not_seen<= 100 ? count_not_seen: "99+"}</CBadge>
      </CDropdownToggle>
      {count_not_seen === 0 ?
        <CDropdownMenu show={isshow} placement="bottom-end" className="pt-0">
          <CDropdownItem header tag="div" className="text-center" color="light">
            <strong color="warning">ไม่มีการแจ้งเตือน</strong>
          </CDropdownItem>
        </CDropdownMenu> :
        <CDropdownMenu show={isshow} placement="bottom-end" className="pt-0" style={{ height: 'auto', }}>
          <CDropdownItem header tag="div" className="text-center" color="light">
            <strong color="danger">คุณมี {count_not_seen} การแจ้งเตือน</strong>
            <label style={{ float: 'right' }}>
              <input
                type="checkbox"
                checked={allRead}
                style={{ verticalAlign: 'middle', cursor: 'pointer' }}
                onChange={() => _onReadAll(!allRead)}
              /> อ่านทั้งหมด
            </label>
          </CDropdownItem>
          <div style={{ overflowY: 'scroll' ,height: '400px'}}>
          {data && data.map((item, idx) => (
            <CDropdownItem
              key={idx}
              onClick={() => _onRead(true, item.notification_code, item.notification_url)} >
              <CIcon
                name="cil-bell"
                className="mr-2 text-warning" />
              {item.notification_title}
            </CDropdownItem>
          ))}
          </div>
           {limit === 10 && <CDropdownItem onClick={() => onSetLimit(99, true)}> แจ้งเตือนเพิ่มเติม... </CDropdownItem>} 
        </CDropdownMenu>}
    </CDropdown>
  )
}

export default TheHeaderDropdownNotif